import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-bootstrap";
import { isUndefined } from "lodash";
import placeholder from "assets/img/placeholder.png";

BienCarousel.propTypes = {
  listaImagenes:PropTypes.array,
};

function BienCarousel({
  listaImagenes,
  ...props
}) {
  
  return (
    <Carousel>
      {listaImagenes?.map((imagen, index) => {
      return (<Carousel.Item key={index}>
        <img
          className="img-fluid"
          src={!isUndefined(imagen) ? imagen : placeholder}
          alt=""
        />
      </Carousel.Item>
      )})}
    </Carousel>    
  );
}

export default BienCarousel;
